import React from 'react'
import styled from 'styled-components'
import { colors } from 'utils'
import Icon from './Icon'

const S = {
    Wrapper: styled.div`
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    `,
    Header: styled.h3`
        font-size: 50px;
        color: ${colors.grayTitle};
        font-weight: bold;
    `
}

const ComingSoonPage = () => (
    <S.Wrapper>
        <Icon icon="rocket" color={colors.grayTitle} size={64} />
        <S.Header>Coming soon!</S.Header>
    </S.Wrapper>
)

export default ComingSoonPage
